export enum ViewMode {
  SCREEN,
  PRINT,
}
